<template>
  <div>
    <notifications></notifications>
    <loader></loader>
    <Navbar></Navbar>
    <Notificationbar></Notificationbar>
    <router-view></router-view>
    <Footer></Footer>
    <SessionTimeOutModalManager></SessionTimeOutModalManager>
  </div>
</template>

<script>
import Navbar from "./components/App/Navbar.vue";
import Notificationbar from "@/components/App/Notificationbar.vue";
import Footer from "@/components/App/Footer.vue";
import SessionTimeOutModalManager from "./components/App/SessionTimeOutModalManager.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    Navbar,
    Footer,
    Notificationbar,
    SessionTimeOutModalManager,
  },
  data() {
    return {};
  },
  watch: {
    '$route'(to, from) {
      document.title = to.meta.title || 'AGATRS'
    }
  },
  computed: {
    // isIdle is now handled by the SessionTimeoutModalManager directly if idleVue is globally available
    // or you might pass it as a prop if idleVue is injected differently.
    // isIdle() {
    //   return this.$store.state.idleVue.isIdle;
    // },
    ...mapGetters({
      isLoggedIn: "authentication/isLoggedIn",
    }),
  },
  methods: {
    ...mapActions({
      restoreContext: "authentication/restoreContext", // left it here if needed for initial app load
      getUsers: "users/getUsers",
    }),
    initializeLayout() {
      if (!this.$rtl.isRTL) {
        this.$rtl.disableRTL();
      }
    },
  },
  created: function () {
    this.restoreContext(); // Restore context on app creation
  },
  mounted() {
    this.initializeLayout();
  },
};
</script>

<style>
.vs__dropdown-toggle  {
  border: 1px  solid rgb(0, 0, 0, 0.5) !important;
}

.el-input__inner{
  border: 1px solid rgb(0, 0, 0, 0.5) !important;
}

/* .white-content .form-control, .white-content .form-group .el-input__inner, .form-group .white-content .el-input__inner, .white-content .el-date-picker .el-input .el-input__inner, .el-date-picker .el-input .white-content .el-input__inner{
  border: 1px solid rgb(0, 0, 0, 0.5) !important;
} */

.vs--disabled .vs__clear, .vs--disabled .vs__dropdown-toggle, .vs--disabled .vs__open-indicator, .vs--disabled .vs__search, .vs--disabled .vs__selected{
  background-color: #E3E3E3 !important;
}

.vue-treeselect {
  border: 1px solid rgb(0, 0, 0, 0.5) !important;
  border-radius: 5px !important;
}

.el-input.is-disabled .el-input__inner{
  background-color: #E3E3E3 !important;
}
.vue-treeselect--disabled .vue-treeselect__control {
  background-color: #E3E3E3 !important;
    }

    .el-radio__input.is-checked .el-radio__inner {
    border-color: #275D34 !important;
    background: #275D34 !important;
}

.el-radio__input.is-checked+.el-radio__label {
    color: #344675 !important;
}

.el-textarea__inner {
  border: 1px solid rgb(0, 0, 0, 0.5) !important;
}

</style>
